/**
 * AI INTERVENTION ORCHESTRATOR LOGIC
 * Koordinerer alle AI-submoduler til en helhetlig intervensjonsleveranse.
 */

import { generate90DayPlan } from './improvementPlanLogic';
import { generateWorkshopAgenda } from './workshopAgendaLogic';
import { generateBoardPresentation } from './boardPresentationLogic';
import { generateLeaderActionPlan } from './leaderActionLogic';

export const ORCHESTRATOR_STATUS = {
  PENDING: 'Venter på data',
  PROCESSING: 'Genererer innsikt',
  COMPLETED: 'Klar for utrulling',
  CRITICAL: 'Prioritert intervensjon'
};

export const runOrchestration = (assessmentData) => {
  const { metrics, companyName, departments, previousScore } = assessmentData;
  
  // 1. Sjekk automatiseringsregler
  const highRiskIndices = Object.values(metrics).filter(v => v > 70 || v < 40).length;
  const isPriorityCase = highRiskIndices >= 2;
  const hasCriticalDept = departments.some(d => d.metrics.we < 40);
  const isScoreDrop = previousScore > metrics.we;

  // 2. Generer alle leveranser parallelt (simulert)
  return {
    id: `ORCH-${Date.now()}`,
    timestamp: new Date().toISOString(),
    status: isPriorityCase ? ORCHESTRATOR_STATUS.CRITICAL : ORCHESTRATOR_STATUS.COMPLETED,
    automationFlags: {
      isPriorityCase,
      hasCriticalDept,
      isScoreDrop
    },
    deliverables: [
      {
        id: 'exec-1',
        type: 'Executive Report',
        title: 'Strategisk Analyse Q2',
        status: 'Generert',
        icon: 'Award'
      },
      {
        id: 'board-1',
        type: 'Board Summary',
        title: 'Styreoppsummering & Vedtak',
        status: 'Generert',
        icon: 'FileText',
        data: generateBoardPresentation({ metrics, companyName, period: "Q2 2024", strengths: ["Kultur"], risks: ["Stress"], recommendations: ["Plan"] })
      },
      {
        id: 'plan-90',
        type: '90 Day Plan',
        title: 'Strategisk Veikart',
        status: 'Generert',
        icon: 'Target',
        data: generate90DayPlan(metrics, companyName)
      },
      {
        id: 'dept-plan',
        type: 'Dept Action Plan',
        title: 'Operativ plan: Utvikling',
        status: 'Generert',
        icon: 'Layers'
      },
      {
        id: 'workshop-1',
        type: 'Workshop Package',
        title: 'Agenda: Psykologisk Trygghet',
        status: 'Generert',
        icon: 'Users'
      }
    ],
    alerts: [
      isPriorityCase && "Kritisk intervensjon: To eller flere indekser er i rød sone.",
      hasCriticalDept && "Eskaleringsplan: Utviklingsavdelingen krever umiddelbar lederstøtte.",
      isScoreDrop && "Executive Alert: Organisasjonsscoren har falt siden forrige periode."
    ].filter(Boolean)
  };
};

export const mockOrchestratorInput = {
  companyName: "TechCorp AS",
  previousScore: 62,
  metrics: {
    we: 48,
    ohs: 45,
    cri: 72,
    stress: 82,
    psi: 35,
    leadership: 42,
    culture: 48
  },
  departments: [
    { id: 'd1', name: 'Utvikling', metrics: { we: 38 } },
    { id: 'd2', name: 'Salg', metrics: { we: 55 } }
  ]
};